/**
 * Camera location options — the managed list behind Settings → Manage Camera Location.
 *
 * A location carries two colours, not one: an alert card that has no priority is filled
 * with `color` outright, so the colour drawn on it travels with it. Nothing derives one
 * from the other — a readable pairing is the client's choice, and guessing it is how a
 * card ends up with white text on a pale yellow fill.
 *
 * The default answers "what is drawn for a location saved before the text colour existed",
 * and it must stay in step with the schema default in the API's
 * models/alert_location_dropdown_options.model.js.
 */

export const DEFAULT_LOCATION_TEXT_COLOR = '#000000';

/**
 * Canonicalise a colour coming back from the API. The alert projection has a history of
 * delivering the literal strings 'null' and 'undefined' in these fields, which is why this
 * is not a plain truthiness check.
 */
export function toLocationColor(raw: unknown, fallback: string): string {
  if (typeof raw !== 'string') {
    return fallback;
  }
  const trimmed = raw.trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
    return fallback;
  }
  return trimmed;
}
